export default __webpack_public_path__ + "static/media/Arrow-Right.a0bb3b02.svg";